export default {
  // BTC balance
  btcBalance: "BTC Balance",
  updated: "Updated",

  // Transaction overview
  transactionOverview: "Transaction Overview",
  cumulativeInOutAmount: "Cumulative In & Out Amount",
  inOutTransactions: "In & Out Transactions",
  avgInOutAmount: "Average In & Out Amount",
  firstTransactionTime: "First Transaction Time",
};
